import { FilterDropdown } from "@repo/ui";

import type { DropDownProps } from ".";

interface Props extends DropDownProps {}

export function BranchesDropdown(props: Props) {
	return (
		<FilterDropdown
			{...props}
			id="branchIds"
			allOption
			values={props.options?.data ?? []}
			objectName="Offices"
			fullLength
			isMulti
		/>
	);
}
